import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-924610b0")
const _hoisted_1 = { class: "_tpopup" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = {
  key: 0,
  class: "body"
}
const _hoisted_4 = {
  key: 1,
  class: "body"
}
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "directions" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconButton = _resolveComponent("IconButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", null, _toDisplayString(_ctx.header), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.helloThere), 1)
    ]),
    (_ctx.body && _ctx.body.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("p", null, _toDisplayString(_ctx.body), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.link && _ctx.link.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("p", null, [
            _createElementVNode("a", {
              href: _ctx.link,
              target: "_blank"
            }, _toDisplayString(_ctx.linkText), 9, _hoisted_5)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", null, [
        (_ctx.stage>0)
          ? (_openBlock(), _createBlock(_component_IconButton, {
              key: 0,
              icon: "back",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('back')))
            }))
          : _createCommentVNode("", true)
      ]),
      _hoisted_7,
      _createElementVNode("div", null, [
        (_ctx.stage<_ctx.max)
          ? (_openBlock(), _createBlock(_component_IconButton, {
              key: 0,
              icon: _ctx.tick?'tick':'forward',
              type: "svg",
              text: _ctx.nextText||'Next',
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('forward')))
            }, null, 8, ["icon", "text"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}